import { v1 } from "uuid";

export function getRandomKey(){
    return v1()
}